module.exports = __webpack_public_path__ + "media/your_career_track/featured-profiles-25454462.png";